/// <reference path="../_references.ts"/>

module App.Administrative.Tags {
	export type TagColor = {
		id: number;
		hex: string;
		rgb: string;
	}

	export type Tag = {
		id: number;
		name: string;
		tag_color: TagColor;
	}
}